import { render, staticRenderFns } from "./PAEE.vue?vue&type=template&id=587bd241&scoped=true"
import script from "./PAEE.vue?vue&type=script&lang=js"
export * from "./PAEE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587bd241",
  null
  
)

export default component.exports